import { render, staticRenderFns } from "./InvoiceSetupList.vue?vue&type=template&id=656d5bbc"
import script from "./InvoiceSetupList.vue?vue&type=script&lang=js"
export * from "./InvoiceSetupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports